export interface OrderEventType {
  title: string;
  code: number;
}

export const OrderEvent: { [key: string]: OrderEventType } = {
  EXCEPTION: {
    title: '异常',
    code: -99,
  },
  CANCELLED: {
    title: '司机取消订单',
    code: -3,
  },
  ABANDONED: {
    title: '司机放弃订单',
    code: -2,
  },
  REJECTED: {
    title: '拒绝',
    code: -1,
  },
  CREATED: {
    title: '订单创建 司机申请接单',
    code: 0,
  },
  AGREED: {
    title: '货主确认司机运输',
    code: 1,
  },
  LOADED: {
    title: '车辆出发 司机装车',
    code: 2,
  },
  DELIVERED: {
    title: '车辆到达 司机卸货',
    code: 3,
  },
  COMPLETED: {
    title: '订单完成 货主确认收货',
    code: 4,
  },
  FORCE_ARREIVED: {
    title: '系统强制送达',
    code: 20,
  },
  OTHER: {
    title: '其他事件',
    code: 99,
  },
};

// 获取事件类型标题
export const getOrderEventTitle = (code: number): string => {
  const event = Object.values(OrderEvent).find(event => event.code === code);
  return event?.title || '未知事件';
};

export default OrderEvent;